<!--suppress TypeScriptUnresolvedVariable -->
<div class="ec-members-container" *ngIf="community|async as community">
    <div *ngIf="community.entity" class="grey-border">
        <div fxLayout="row" fxLayoutAlign="start start" class="mb-32 mt-16" fxLayoutGap="50px">
            <div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="36px">
                <div>
                    <button app-primary-button [disabled]="!community.canUpdate" (click)="onClickNewMember()">
                        <app-icon name="fal-plus-square"></app-icon>
                        {{ 'Add new subject'|i18n }}
                    </button>
                </div>
                <div>
                    <button app-ghost-button [disabled]="!community.canUpdate"
                            (click)="onclickUploadExcel()">
                        <app-icon name="fal-layer-plus"></app-icon>
                        {{ 'Create multiple subjects'|i18n }}
                    </button>
                </div>
            </div>
            <div fxLayout="row" fxLayoutAlign="start start" class="w-100">
                <div fxLayout="column" fxLayoutGap="36px" class="w-100">
                    <div fxLayout="row" fxLayoutAlign="space-between" fxLayoutGap="36px">
                        <div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="35px">
                            <div fxLayout="row" fxLayoutAlign="start center">
                                {{ 'Participation type'|i18n }}:
                                <mat-select app-small-select
                                            [formControl]="searchFilters.types"
                                            class="status-filter ml-8">
                                    <mat-option *ngFor="let type of PARTICIPATION_TYPES" class="mat-primary"
                                                [value]="type">
                                        {{ type + '__{membership}'|i18n }}
                                    </mat-option>
                                </mat-select>
                            </div>

                            <div fxLayout="row" fxLayoutAlign="start center">
                                {{ 'Account'|i18n }}:
                                <mat-select multiple app-small-select
                                            [formControl]="searchFilters.status"
                                            class="status-filter ml-8">
                                    <mat-select-trigger *appVar="searchFilters.status.value as selectedStates">
                                    <span *ngIf="selectedStates.length < MEMBER_STATES.length">
                                        {{ mkSelectedStatesTrigger(selectedStates) }}
                                    </span>
                                        <span *ngIf="selectedStates.length === MEMBER_STATES.length">
                                        {{ 'All states__{membership}'|i18n }}
                                    </span>
                                    </mat-select-trigger>
                                    <mat-option *ngFor="let state of MEMBER_STATES" class="mat-primary"
                                                [value]="state" [disabled]="!canFilterState(state)">
                                        {{ state|ecMemberState|i18n }}
                                    </mat-option>
                                </mat-select>
                            </div>
                        </div>
                        <div app-input-container class="member-search-container"
                             *appVar="searchTextFilter as textFilterCtrl">
                            <input app-input [formControl]="textFilterCtrl"
                                   class="member-search"
                                   [spellcheck]="false"
                                   [placeholder]="'Search by POD, email, last name or company'|i18n">
                            <app-icon *ngIf="!!textFilterCtrl.value" name="fal-times" class="right-symbol clear"
                                      (click)="textFilterCtrl.setValue('')">
                            </app-icon>
                            <svg *ngIf="!textFilterCtrl.value" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"
                                 class="right-symbol mag-glass">
                                <!--! Font Awesome Pro 6.2.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. -->
                                <path d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352c79.5 0 144-64.5 144-144s-64.5-144-144-144S64 128.5 64 208s64.5 144 144 144z"/>
                            </svg>
                        </div>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="start center">
                        <span class="txt-p-16-7">{{ "Subjects with"|i18n }}:</span>
                        <mat-select app-small-select [formControl]="searchFilters.podRoleTypes" class="status-filter ml-30">
                            <mat-option *ngFor="let role of roleTypes" class="mat-primary" [value]="role">
                                {{ role|genericPipe|i18n }}
                            </mat-option>
                        </mat-select>
                        <mat-checkbox app-checkbox [formControl]="searchFilters.podWithoutDate" class="ml-30">
                            <span class="txt-p-16-4">{{ 'at least one POD without a date'|i18n }}</span>
                        </mat-checkbox>
                        <mat-checkbox app-checkbox [formControl]="searchFilters.deactivatedPod" class="ml-30">
                            <span class="txt-p-16-4">{{ 'at least one deactivated POD'|i18n }}</span>
                        </mat-checkbox>
                        <div fxLayout="row" fxLayoutAlign="start center" class="ml-30">
                            <mat-slide-toggle app-toggle [formControl]="searchFilters.hideDisabled"
                                              class="txt-p-16-4 mr-22">
                            </mat-slide-toggle>
                            {{ 'Hide disabled'|i18n }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div *ngIf="community.canView; else unviewableCommunity">
            <ng-container *appVar="members|async as members">
                <ng-container *ngIf="members; else loadingMembers">
                    <ng-container *ngIf="members.members.length">
                        <table mat-table app-table [dataSource]="members.members"
                               *appVar="expandedMember|async as expandedMember"
                               multiTemplateDataRows class="member-table">
                            <ng-container matColumnDef="chevron">
                                <th mat-header-cell *matHeaderCellDef>
                                </th>
                                <td mat-cell *matCellDef="let row"
                                    class="chevron" [ngClass]="{'expanded': row === expandedMember}">
                                    <app-icon
                                            [name]="row === expandedMember ? 'fal-chevron-down' : 'fal-chevron-right'">
                                    </app-icon>
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="firstName">
                                <th mat-header-cell *matHeaderCellDef>
                                    <div fxLayout="row" fxLayoutAlign="start">
                                        {{ 'Name'|i18n }}
                                    </div>
                                </th>
                                <td mat-cell
                                    *matCellDef="let row">{{ row.member.personal_data.first_name || '-' }}
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="lastName">
                                <th mat-header-cell *matHeaderCellDef>
                                    <div fxLayout="row" fxLayoutAlign="start center">
                                        {{ 'Surname'|i18n }}
                                        <button *ngIf="getSortDirection(SortCriterion.LAST_NAME) === SortDirection.ASC"
                                                app-icon-button class="sort-button ml-16"
                                                (click)="onClickSortBy(SortCriterion.LAST_NAME, SortDirection.DESC)">
                                            <app-icon name="fal-sort-amount-up"></app-icon>
                                        </button>
                                        <button *ngIf="getSortDirection(SortCriterion.LAST_NAME) === SortDirection.DESC"
                                                app-icon-button class="sort-button ml-16"
                                                (click)="onClickSortBy(SortCriterion.LAST_NAME, SortDirection.ASC)">
                                            <app-icon name="fal-sort-amount-down"></app-icon>
                                        </button>
                                    </div>
                                </th>
                                <td mat-cell
                                    *matCellDef="let row">{{ row.member.personal_data.last_name || '-' }}
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="companyName">
                                <th mat-header-cell *matHeaderCellDef>
                                    <div fxLayout="row" fxLayoutAlign="start center">
                                        {{ 'Business name'|i18n }}
                                        <button *ngIf="getSortDirection(SortCriterion.COMPANY_NAME) === SortDirection.ASC"
                                                app-icon-button class="sort-button ml-16"
                                                (click)="onClickSortBy(SortCriterion.COMPANY_NAME, SortDirection.DESC)">
                                            <app-icon name="fal-sort-amount-up"></app-icon>
                                        </button>
                                        <button *ngIf="getSortDirection(SortCriterion.COMPANY_NAME) === SortDirection.DESC"
                                                app-icon-button class="sort-button ml-16"
                                                (click)="onClickSortBy(SortCriterion.COMPANY_NAME, SortDirection.ASC)">
                                            <app-icon name="fal-sort-amount-down"></app-icon>
                                        </button>
                                    </div>
                                </th>
                                <td mat-cell
                                    *matCellDef="let row">{{ row.member.personal_data.company_name || '-' }}
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="participationType">
                                <th mat-header-cell *matHeaderCellDef>
                                    <div fxLayout="row" fxLayoutAlign="center">
                                        {{ 'Participate as'|i18n }}:
                                    </div>
                                </th>
                                <td mat-cell *matCellDef="let row" class="status">
                                    <div fxLayout="row" fxLayoutAlign="center">
                                        <div *appVar="row.member.participation_type as participationType"
                                             class="participation-type">
                                            <div *ngIf="isDefined(participationType)"
                                                 class="status-box" [ngClass]="'type-' + participationType">
                                                <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="8px">
                                                    <app-icon [name]="participationType|ecSubjectParticipationTypeIcon"
                                                              class="status-icon"
                                                              [ngClass]="'type-' + participationType">
                                                    </app-icon>
                                                    <div>{{ participationType|genericPipe|i18n }}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="accessType">
                                <th mat-header-cell *matHeaderCellDef>
                                    <div fxLayout="row" fxLayoutAlign="center">
                                        {{ 'Access to'|i18n }}:
                                    </div>
                                </th>
                                <td mat-cell *matCellDef="let row" class="status">
                                    <div fxLayout="row" fxLayoutAlign="center">
                                        <div *appVar="row.member.access_type as accessType" class="access-type">
                                            <div *ngIf="isDefined(accessType)"
                                                 class="status-box" [ngClass]="'access-' + accessType">
                                                <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="8px">
                                                    <app-icon [name]="accessType|ecSubjectAccessTypeIcon"
                                                              class="status-icon"
                                                              [ngClass]="'access-' + accessType">
                                                    </app-icon>
                                                    <div>{{ (accessType + '__{table}')|i18n }}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="resources">
                                <th mat-header-cell *matHeaderCellDef>
                                    <div fxLayout="row" fxLayoutAlign="center">
                                        {{ 'POD'|i18n }}
                                    </div>
                                </th>
                                <td mat-cell *matCellDef="let row" class="resources">
                                    <div fxLayout="row" fxLayoutAlign="center">
                                        <div>{{ row.resources.length }}</div>
                                        <app-icon *ngIf="hasPodWithMissingDates(row)"
                                                  icon-color-w name="fas-exclamation-triangle" class="ml-10"
                                                  [title]="'This subject has PODs with no activation date.'|i18n">
                                        </app-icon>
                                    </div>
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="status">
                                <th mat-header-cell *matHeaderCellDef>
                                    <div fxLayout="row" fxLayoutAlign="center">
                                        {{ 'Account status__{table}'|i18n }}:
                                    </div>
                                </th>
                                <td mat-cell *matCellDef="let row" class="status">
                                    <div fxLayout="row" fxLayoutAlign="center">
                                        <div *appVar="row.member.state as memberState" class="member-status">
                                            <div *ngIf="isDefined(memberState) && !(isDefined(row.account?.enabled) && !row.account.enabled)"
                                                 class="status-box" [ngClass]="'member-' + memberState">
                                                <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="8px">
                                                    <app-icon [name]="memberState|ecMemberStateIcon"
                                                              class="status-icon"
                                                              [ngClass]="'member-' + memberState">
                                                    </app-icon>
                                                    <div>{{ memberState|ecMemberState|i18n }}</div>
                                                </div>
                                            </div>
                                            <div *ngIf="isDefined(row.account?.enabled) && !row.account.enabled"
                                                 class="status-box member-disabled">
                                                <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="8px">
                                                    <app-icon name="fal-ban"
                                                              class="status-icon member-disabled"></app-icon>
                                                    <div>{{ 'Disabled'|i18n }}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="in">
                                <th mat-header-cell *matHeaderCellDef>
                                    <div fxLayout="row" fxLayoutAlign="center center">
                                        {{ 'Created on__{column}'|i18n }}
                                        <button *ngIf="getSortDirection(SortCriterion.CREATED_AT) === SortDirection.ASC"
                                                app-icon-button class="sort-button ml-16"
                                                (click)="onClickSortBy(SortCriterion.CREATED_AT, SortDirection.DESC)">
                                            <app-icon name="fal-sort-amount-up"></app-icon>
                                        </button>
                                        <button *ngIf="getSortDirection(SortCriterion.CREATED_AT) === SortDirection.DESC"
                                                app-icon-button class="sort-button ml-16"
                                                (click)="onClickSortBy(SortCriterion.CREATED_AT, SortDirection.ASC)">
                                            <app-icon name="fal-sort-amount-down"></app-icon>
                                        </button>
                                    </div>
                                </th>
                                <td mat-cell *matCellDef="let row">
                                    <div fxLayout="row" fxLayoutAlign="center">
                                        <div>
                                            {{ isDefined(row.member.created_at) ? (row.member.created_at|i18nDate) : '--/--/--' }}
                                        </div>
                                    </div>
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="registered">
                                <th mat-header-cell *matHeaderCellDef>
                                    <div fxLayout="row" fxLayoutAlign="center center">
                                        {{ 'Registered since'|i18n }}
                                        <button *ngIf="getSortDirection(SortCriterion.REGISTERED_SINCE) === SortDirection.ASC"
                                                app-icon-button class="sort-button ml-16"
                                                (click)="onClickSortBy(SortCriterion.REGISTERED_SINCE, SortDirection.DESC)">
                                            <app-icon name="fal-sort-amount-up"></app-icon>
                                        </button>
                                        <button *ngIf="getSortDirection(SortCriterion.REGISTERED_SINCE) === SortDirection.DESC"
                                                app-icon-button class="sort-button ml-16"
                                                (click)="onClickSortBy(SortCriterion.REGISTERED_SINCE, SortDirection.ASC)">
                                            <app-icon name="fal-sort-amount-down"></app-icon>
                                        </button>
                                    </div>
                                </th>
                                <td mat-cell *matCellDef="let row">
                                    <div fxLayout="row" fxLayoutAlign="center">
                                        <div>
                                            {{ isDefined(row.member.registered_since) ? (row.member.registered_since|i18nDate) : '--/--/--' }}
                                        </div>
                                    </div>
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="actions">
                                <th mat-header-cell *matHeaderCellDef>
                                </th>
                                <td mat-cell *matCellDef="let row" class="actions">
                                    <div fxLayout="row" fxLayoutAlign="end" fxLayoutGap="24px">
                                        <button app-icon-button [disabled]="!community.canUpdate"
                                                [title]="'Edit subject settings'|i18n"
                                                (click)="onClickEditMember(row, $event)">
                                            <app-icon name="fal-pencil-alt"></app-icon>
                                        </button>
                                        <button app-icon-button class="app-button-alert"
                                                [disabled]="!community.canUpdate"
                                                [title]="'Delete subject'|i18n"
                                                (click)="onClickDeleteMember(row, $event)">
                                            <app-icon name="fal-trash-alt"></app-icon>
                                        </button>
                                    </div>
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="expandedDetail">
                                <td mat-cell *matCellDef="let row" [attr.colspan]="displayedColumns.length">
                                    <div class="member-detail-container"
                                         [@detailExpand]="row === expandedMember ? 'expanded' : 'collapsed'">
                                        <div class="member-details">
                                            <app-ec-member-details [member]="row.member"
                                                                   [account]="row.account"
                                                                   [resources]="mkPodResources(row)"
                                                                   [canUpdate]="community.canUpdate"
                                                                   [show2fa]="true"
                                                                   [podsErrorsMap]="podsErrorsMap"
                                                                   [network]="community.entity"
                                                                   (deleteMemberUser)="onDeleteUser(row)"
                                                                   (disableAccount)="onDisableAccount(row)"
                                                                   (reactivateAccount)="onReactivateAccount(row)"
                                                                   (forcePwdChange)="onForcePwdChange(row)"
                                                                   (reset2FA)="onReset2FA(row)">
                                            </app-ec-member-details>
                                        </div>
                                    </div>
                                </td>
                            </ng-container>
                            <tr mat-header-row *matHeaderRowDef="displayedColumns">
                            </tr>
                            <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="app-row"
                                [ngClass]="{'app-expanded-row': expandedMember === row}"
                                (click)="onSelectMember(row)">
                            </tr>
                            <tr mat-row *matRowDef="let row; columns: ['expandedDetail']"
                                class="app-detail-row app-border-row"
                                [ngClass]="{'app-expanded-row': expandedMember === row}">
                            </tr>
                        </table>
                    </ng-container>
                    <div *ngIf="!members.members.length" fxLayout="row" fxLayoutAlign="center">
                        {{ 'No subjects'|i18n }}
                    </div>
                </ng-container>
                <mat-paginator #paginator app-paginator class="member-paginator"
                               [ngClass]="{'collapsed': !members || members.total === 0 }"
                               [length]="members?.total" [pageSize]="PAGE_SIZE" [pageSizeOptions]="PAGE_SIZES">
                </mat-paginator>
            </ng-container>
        </div>
        <ng-container *appVar="members|async as members">
            <ng-container *ngIf="members">
                <div class="mt-24" fxLayoutAlign="end center">
                    <button *ngIf="members.total" app-ghost-button
                            (click)="exportMembersToExcel(community.entity.id, members.total, community.entity.name)"
                            [disabled]="templateIsDownloading">
                        <app-icon name="fal-file-excel"></app-icon>
                        {{ 'Export to Excel'|i18n }}
                    </button>
                </div>
            </ng-container>
        </ng-container>
    </div>
</div>

<ng-template #newMember let-data let-close="close">
    <div class="new-member">
        <app-new-ec-member [community]="data.community"
                           [member]="data.member"
                           (closeDialog)="close($event)">
        </app-new-ec-member>
    </div>
</ng-template>


<ng-template #membersNotCreated let-close="close">
    <div fxLayout="column" fxLayoutGap="16px" class="member-error-panel">
        <div fxLayout="column">
            <div fxLayout="row" fxLayoutAlign="center" class="txt-h-16-4">
                {{ ('Try again creating these'|i18n) }}
                &nbsp;
                <span style="font-weight: bold"> {{ deletedMembers.length }} </span>
                &nbsp;
                {{ ('subjects' | i18n) }}
            </div>
            <div fxLayout="row" fxLayoutAlign="center" class="txt-h-16-4">
                {{ 'If you want to use the massive import function, first remove the subjects detailed here and then upload a new file containing only these deleted subjects'|i18n }}
            </div>
        </div>
        <div fxLayout="row" fxLayoutAlign="space-evenly center">
            <div class="panel" fxLayout="column" fxLayoutGap="16px">
                <div fxLayout="row" *ngFor="let member of deletedMembersPage" fxLayoutGap="30px">
                    <div fxLayout="column" fxLayoutAlign="center start">
                        <div fxLayout="row" fxLayoutGap="10px">
                            <app-icon class="fa-icon" name="fal-user"></app-icon>
                            <span>  {{ member.pod }} </span>
                        </div>
                    </div>
                    <div fxLayout="column" class="txt-s-16-4" fxLayoutAlign="center start">
                        {{ member.name }}
                    </div>
                </div>
            </div>
        </div>
        <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px"
             *ngIf="deletedMembers.length > deletedMembersErrorsPageSize">
            <button app-primary-button (click)="previousMembersErrorsPage()"
                    [disabled]="deletedMembersErrorsPage === 1"> {{ "Back" | i18n }}
            </button>
            <button app-primary-button (click)="nextMembersErrorsPage()"
                    [disabled]="deletedMembersErrorsPage === deletedMembersErrorsTotalPages">{{ "Show more errors" | i18n }}
            </button>
        </div>
        <div fxLayout="row" fxLayoutAlign="center center" app-dialog-actions>
            <button app-primary-button (click)="close(true)" class="confirm-button">
                {{ 'Ok'|i18n }}
            </button>
        </div>
    </div>
</ng-template>

<ng-template #deleteMember let-data let-close="close">
    <div fxLayout="row" fxLayoutAlign="center" class="txt-a-18-7">
        {{ 'Removal cannot be undone'|i18n }}
    </div>
    <div fxLayout="row" fxLayoutAlign="center" class="mt-36">
        {{ 'Are you sure you want to delete {0} along with energy resources and data?'|i18n:data.member.name }}
    </div>
    <div fxLayout="row" fxLayoutAlign="center" class="mt-16">
        {{ 'Alternatively, you can disable the subject\'s account and/or deactivate their PODs, while keeping the resources on the platform.'|i18n }}
    </div>
    <div fxLayout="row" fxLayoutAlign="space-between" app-dialog-actions>
        <button app-ghost-button (click)="close(false)">
            {{ 'No, cancel'|i18n }}
        </button>
        <button app-primary-button (click)="close(true)">
            {{ 'Yes, delete subject and resources'|i18n }}
        </button>
    </div>
</ng-template>

<ng-template #disableMember let-data let-close="close">
    <div fxLayout="row" fxLayoutAlign="center center" class="ml-42 mr-42 mt-30">
        {{ 'You are about to disable {0} from using the app'|i18n:data.member.name }}
    </div>
    <div fxLayout="row" fxLayoutAlign="center center" class="ml-42 mr-42 mt-30">
        {{ 'This action will take effect immediately but you can re-enable the user with the "Enable" button'|i18n }}
    </div>
    <div fxLayout="row" fxLayoutAlign="space-between" app-dialog-actions>
        <button app-ghost-button (click)="close(false)">
            {{ 'No, cancel'|i18n }}
        </button>
        <button app-primary-button (click)="close(true)">
            {{ 'Yes, confirm'|i18n }}
        </button>
    </div>
</ng-template>

<ng-template #deleteMemberUser let-data let-close="close">
    <div fxLayout="row" fxLayoutAlign="center center" class="ml-42 mr-42 mt-30">
        {{ 'You are about to delete {0} account and prevent his access to the app'|i18n:data.member.name }}
    </div>
    <div fxLayout="row" fxLayoutAlign="center center" class="ml-42 mr-42 mt-30">
        {{ 'This action will take effect immediately but you can re-invite the user later on using the edit button'|i18n }}
    </div>
    <div fxLayout="row" fxLayoutAlign="space-between" app-dialog-actions>
        <button app-ghost-button (click)="close(false)">
            {{ 'No, cancel'|i18n }}
        </button>
        <button app-primary-button (click)="close(true)">
            {{ 'Yes, confirm'|i18n }}
        </button>
    </div>
</ng-template>

<ng-template #forcePwdChange let-data let-close="close">
    <div fxLayout="row" fxLayoutAlign="center center" class="ml-42 mr-42 mb-20">
        {{ 'You are about to ask the user {0} {1} to change the password in order to use the platform.'|i18n:data.firstName:data.lastName }}
    </div>
    <div fxLayout="row" fxLayoutAlign="center center" class="ml-42 mr-42">
        {{ 'The user will see the password change request on next login.'|i18n }}
    </div>
    <div fxLayout="row" fxLayoutAlign="space-between" app-dialog-actions>
        <button app-ghost-button (click)="close(false)">
            {{ 'No, cancel'|i18n }}
        </button>
        <button app-primary-button (click)="close(true)">
            {{ 'Yes, confirm'|i18n }}
        </button>
    </div>
</ng-template>

<ng-template #force2FAReset let-data let-close="close">
    <div fxLayout="row" fxLayoutAlign="center center" class="ml-42 mr-42 mb-20">
        {{ 'You are about to reset 2FA for the user {0} {1}.'|i18n:data.firstName:data.lastName }}
    </div>
    <div fxLayout="row" fxLayoutAlign="center center" class="ml-42 mr-42">
        {{ 'On next login, the user will have to re-configure two-factor authentication.'|i18n }}
    </div>
    <div fxLayout="row" fxLayoutAlign="space-between" app-dialog-actions>
        <button app-ghost-button (click)="close(false)">
            {{ 'No, cancel'|i18n }}
        </button>
        <button app-primary-button (click)="close(true)">
            {{ 'Yes, confirm'|i18n }}
        </button>
    </div>
</ng-template>

<ng-template #unviewableCommunity>
    <div fxLayout="row" fxLayoutAlign="center" class="mt-16">
        {{ 'Insufficient permissions to view energy community members'|i18n }}
    </div>
</ng-template>

<ng-template #loadingMembers>
    <div fxLayout="row" fxLayoutAlign="center center" class="mt-24 mb-16">
        <mat-spinner app-spinner diameter="20"></mat-spinner>
        <span class="pl-8">{{ 'Loading subjects'|i18n }}...</span>
    </div>
</ng-template>

<ng-template #spinner let-data="data" let-close="close">
    <app-spinner [spinnerDataSubj]="data"
                 (closeSpinner)="close()">
    </app-spinner>
</ng-template>

<ng-template #uploadMembers let-data let-close="close">
    <div fxLayout="column" fxLayoutAlign="center center">
        <div class="app-dialog-background" fxLayout="row" fxLayoutAlign="center center">
            <app-members-massive-import [resourceId]="data.communityId" (uploadedData)="uploadMemberFile($event)">
            </app-members-massive-import>
        </div>
    </div>
</ng-template>

<ng-template #uploadMembersError let-data let-close="close">
    <div fxLayout="column" fxLayoutGap="32px">
        <div fxLayout="column">
            <span class="massive-import-error-title">{{ data.message[0] }}</span>
            <span class="massive-import-error-title">{{ data.message[1] }}</span>
        </div>
        <div class="ml-42 mr-42" fxLayout="column" fxLayoutGap="32px">

            <ng-container *ngIf="massiveImportErrorsList.length>0">
                <span class="text-2">{{ "Please check the following fields and try again:"|i18n }}</span>
                <div class="panel" fxLayout="column" fxLayoutGap="20px">
                    <ul class="text-2">
                        <li *ngFor="let err of massiveImportErrorsListPage">{{ err }}</li>
                    </ul>
                    <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px"
                         *ngIf="massiveImportErrorsList.length > massiveImportErrorsPageSize">
                        <button app-primary-button (click)="previousErrorsPage()"
                                [disabled]="massiveImportErrorsCurrentPage === 1"> {{ "Back" | i18n }}
                        </button>
                        <button app-primary-button (click)="nextErrorsPage()"
                                [disabled]="massiveImportErrorsCurrentPage === massiveImportErrorsTotalPages">{{ "Show more errors" | i18n }}
                        </button>
                    </div>
                </div>
            </ng-container>

            <ng-container *ngIf="failedSubjectsList.length>0">
                <span class="text-2">{{ "The following subjects could not be created:"|i18n }}</span>
                <div class="panel" fxLayout="column" fxLayoutGap="20px">
                    <ul class="text-2">
                        <li *ngFor="let err of failedSubjectsListPage">{{ err }}</li>
                    </ul>
                    <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px"
                         *ngIf="failedSubjectsList.length > failedSubjectsPageSize">
                        <button app-primary-button (click)="previousFailedSubjectsPage()"
                                [disabled]="failedSubjectsCurrentPage === 1">
                            {{ "Back" | i18n }}
                        </button>
                        <button app-primary-button (click)="nextFailedSubjectsPage()"
                                [disabled]="failedSubjectsCurrentPage === failedSubjectsTotalPages">
                            {{ "Show more subjects" | i18n }}
                        </button>
                    </div>
                </div>
            </ng-container>

            <ng-container *ngIf="successfulSubjectsList.length>0">
                <span class="text-2">{{ "The following subjects have been created:"|i18n }}</span>
                <div class="panel" fxLayout="column" fxLayoutGap="20px">
                    <ul class="text-2">
                        <li *ngFor="let err of successfulSubjectsListPage">{{ err }}</li>
                    </ul>
                    <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px"
                         *ngIf="successfulSubjectsList.length > successfulSubjectsPageSize">
                        <button app-primary-button (click)="previousSuccessfulSubjectsPage()"
                                [disabled]="successfulSubjectsCurrentPage === 1">
                            {{ "Back" | i18n }}
                        </button>
                        <button app-primary-button (click)="nextSuccessfulSubjectsPage()"
                                [disabled]="successfulSubjectsCurrentPage === successfulSubjectsTotalPages">
                            {{ "Show more subjects" | i18n }}
                        </button>
                    </div>
                </div>
            </ng-container>

            <ng-container *ngIf="massiveImportErrorsList.length==0">
                <span class="text-2">{{ "We advice yo to check:"|i18n }}</span>
                <ul class="text-2">
                    <li>{{ "that you have entered numerical values where required;" | i18n }}</li>
                    <li>{{ "that you have inserted photovoltaic implants where required;" | i18n }}</li>
                    <li>{{ "that you filled the row 'injected' only if there's a photovoltaic implant available;" | i18n }}</li>
                    <li>{{ "that you have filled all the required fields for each and every row;" | i18n }}</li>
                    <li>{{ "that you have uploaded a maximum of 100 subjects;" | i18n }}</li>
                    <li>{{ "that you made sure that the Energy Community has an activation date before specifying it for the subjects." | i18n }}
                        <br>
                        {{ "Remember that subjects activation date must follow the Energy Community activation date;" | i18n }}
                    </li>
                </ul>
            </ng-container>
        </div>
        <div fxLayout="row" fxLayoutAlign="center center" app-dialog-actions>
            <button app-primary-button (click)="close(true)">
                {{ 'Ok'|i18n }}
            </button>
        </div>
    </div>
</ng-template>
